import { render, staticRenderFns } from "./otp_page.vue?vue&type=template&id=206f6797&scoped=true&"
import script from "./otp_page.vue?vue&type=script&lang=js&"
export * from "./otp_page.vue?vue&type=script&lang=js&"
import style0 from "./otp_page.vue?vue&type=style&index=0&id=206f6797&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206f6797",
  null
  
)

export default component.exports